import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;

import "@/assets/fonts.css";

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

import { soundFx } from "./mixins/soundFx.js";
Vue.mixin(soundFx);
